<form [formGroup]="notificationForm">
  <div class="dashboard-tile">
    <div class="tile-header">
      <div *ngIf="_notification?.id" class="tile-header-title">Update Notification <span class="text-primary">{{_notification.subject}}</span></div>
      <div *ngIf="!_notification?.id" class="tile-header-title">New Notification</div>
    </div>
    <div class="tile-content">
      <div class="formFieldList">
        <div style="padding-bottom:1.25em;">
          <mat-radio-group aria-label="Notification Type" formControlName="type">
            <mat-radio-button value="INFORMATIONAL">Informational</mat-radio-button>
            <mat-radio-button value="MARKETING">Marketing</mat-radio-button>
            <mat-radio-button value="SYSTEM_ALERT">System Alert</mat-radio-button>
          </mat-radio-group>
        </div>
        <mat-form-field>
          <input matInput placeholder="Subject" formControlName="subject" required>
        </mat-form-field>
        <div style="padding-bottom: 1.25em;">
          <ckeditor [editor]="Editor" [config]="ckConfig" formControlName="message"></ckeditor>
        </div>
      </div>
      <div class="tile-footer">
        <button mat-button type="button" color="primary" (click)="cancel()">Cancel</button>
        <button [disabled]="notificationForm.invalid" mat-raised-button type="submit" color="primary" (click)="saveNotification()">Save</button>
      </div>
    </div>
  </div>
</form>